import { OrganoJudicial, Profesional, Sujeto } from 'src/interfaces'

export function isOrganoJudicial(sujeto: Sujeto): sujeto is OrganoJudicial {
  return (sujeto as OrganoJudicial).codigoConsejo !== undefined
}

export function isProfesional(sujeto: Sujeto): sujeto is Profesional {
  return (sujeto as Profesional).codigoColegiado !== undefined
}
